import { useQuery } from '@apollo/client';
import React from 'react';

import { usePatient } from 'hooks/usePatient/usePatient';
import { APPOINTMENT_TYPES } from 'kb-shared/graphql/queries';
import { AppointmentType } from 'kb-shared/types';
import { BugTracker } from 'kb-shared/utilities/bugTracker';
import { formatPhoneNumber } from 'kb-shared/utilities/phones';
import { memberServicesPhone, memberServicesPhoneHref } from 'screens/Book/memberServicesPhone';
import { NEW_PATIENT_CONSULT_NAME, networkClinicCopy } from 'screens/Book/networkClinicBookingCopy';
import { hasMembership } from 'utilities/patient';

import { AppointmentTypeCard } from './AppointmentTypeCard';

const cardAppointmentType = (name: string, description = ''): AppointmentType => ({
  id: '0',
  name,
  description,
  rateCents: 0,
  videoLink: null,
  virtual: true,
  virtualFert: false,
  category: { id: '0', name: 'Fertility', description: '' },
  channel: 'video',
  minuteDuration: 0,
  hourDuration: 0,
  newPatientVisit: true,
  requireHomeMarket: false,
  inClinicOrVirtualEquivalent: null
});

interface Props {
  onStartQuiz: () => void;
  onSearchNetwork: () => void;
}

export const RecommendEntry = ({ onStartQuiz, onSearchNetwork }: Props) => {
  const { patient } = usePatient();
  const { data } = useQuery<{
    appointmentTypes: Array<{ name: string; description: string; virtual: boolean | null }>;
  }>(APPOINTMENT_TYPES, {
    onError: error => BugTracker.notify(error, 'AppointmentTypesQuery')
  });
  const virtualConsult = data?.appointmentTypes?.find(
    appointmentType => appointmentType.name === NEW_PATIENT_CONSULT_NAME && appointmentType.virtual
  );
  const phone = memberServicesPhone(patient?.patientMembership?.employerPhone);

  return (
    <>
      <AppointmentTypeCard
        appointmentType={cardAppointmentType(
          NEW_PATIENT_CONSULT_NAME,
          virtualConsult?.description ?? ''
        )}
        onClick={onStartQuiz}
      />
      {patient && hasMembership(patient) && (
        <AppointmentTypeCard
          appointmentType={cardAppointmentType(
            'Discuss Your Kindbody Benefit Coverage',
            'Review your employer-sponsored benefits and coverage.'
          )}
          href={memberServicesPhoneHref(phone)}
          buttonLabel={`Call ${formatPhoneNumber(phone)}`}
        />
      )}
      <AppointmentTypeCard
        appointmentType={cardAppointmentType(networkClinicCopy.searchOurNetwork)}
        buttonLabel={networkClinicCopy.findClinic}
        onClick={onSearchNetwork}
      />
    </>
  );
};
